import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { useSiteData } from '../lib/SiteDataContext';
import { resolveImage } from '../lib/api';

const EventsSection = () => {
  const { events, settings } = useSiteData();
  const hs = settings?.home_sections || {};
  const items = (events || []).slice().sort((a, b) => a.order - b.order).slice(0, 3);
  if (items.length === 0) return null;
  return (
    <section className="bg-[#FAF6EC] py-24">
      <div className="mx-auto max-w-[1280px] px-6">
        <div className="mb-12 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#C9A86A]">
              {hs.events_eyebrow || 'Upcoming'}
            </div>
            <h2 className="font-serif text-3xl font-bold leading-tight text-[#0B2545] md:text-[40px]">
              {hs.events_title || 'Government Events'}
            </h2>
            <div className="mt-5 h-[3px] w-16 bg-[#C9A86A]" />
          </div>
          <Link to="/events" className="group inline-flex items-center gap-2 rounded-md bg-[#0B2545] px-5 py-3 text-[14px] font-medium text-white transition hover:bg-[#08203a]">
            {hs.events_button_label || 'All Events'}
            <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((e) => (
            <div key={e.id} className="group overflow-hidden rounded-lg border border-[#E6DDC8] bg-white shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl">
              <div className="relative h-[200px] w-full overflow-hidden">
                {e.image_url && (
                  <img src={resolveImage(e.image_url)} alt={e.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                )}
                <div className="absolute left-4 top-4 flex flex-col items-center justify-center rounded-md bg-[#0B2545] px-3 py-2 text-center text-white shadow-lg">
                  <div className="font-serif text-[22px] font-bold leading-none">{e.day}</div>
                  <div className="mt-1 text-[10px] font-semibold uppercase tracking-widest text-[#C9A86A]">{e.month}</div>
                  <div className="text-[10px] text-white/70">{e.year}</div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="font-serif text-[18px] font-semibold leading-snug text-[#0B2545]">{e.title}</h3>
                <div className="mt-3 inline-flex items-center gap-1.5 text-[12.5px] text-[#0B2545]/65">
                  <MapPin size={13} className="text-[#C9A86A]" />
                  {e.location}
                </div>
                <p className="mt-4 line-clamp-3 text-[13.5px] leading-relaxed text-[#0B2545]/70">{e.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
